<template>
	<div class="simple-progress" style="width:100%;">
		<svg>
			<g class="bg">
				<rect :width="'100%'"></rect>
			</g>
			<g class="markers">
				<line v-for="(n,i) in (unitCount+1)" :key="'i' + i" 
					:x1="((100 / unitCount) * i) + '%'" 
					:x2="((100 / unitCount) * i) + '%'" 
					y1="3px" y2="13px"></line>
			</g>
			<g class="data">
				<line :x1="startPercent + '%'" y1="3px" :x2="startPercent + '%'"  y2="13px"></line>
				<rect :x="startPercent + '%'" :width="(endPercent - startPercent) + '%'"></rect>
				<circle :cx="endPercent + '%'"></circle>
			</g>
		</svg>
		<span class="info" :style="'left:' + endPercent + '%; transform:translateX(-' + endPercent + '%);'">{{valueTitle}}</span>
	</div>
</template>

<script>

export default {
	props: {
		title: { default: "-" },
		valueTitle: { default: "-"},
		unitCount: { type: Number, default: 20 },
		startPercent: { type: Number, default: 0 },
		endPercent: { type: Number, default: 0 }
	},
	data() {
		return {
			
		}
	},
	methods: {
		
	}
}
</script>